import { ComponentRef, Injectable, NgModuleRef, Type, ViewContainerRef } from '@angular/core';
import { NPSModal } from './nps-detail.component';

// Импортируем все компоненты напрямую
import { FreidComponent } from '../../nps/nps-games/freid/freid.component';
import { WitchComponent } from '../../nps/nps-games/witch/witch.component';
import { PuzzleComponent } from '../../nps/nps-games/puzzle/puzzle.component';
import { PaymentComponent } from '../../ui/modals/payment/payment.component';
import { ClimbingWallComponent } from '../../nps/nps-games/climbing-wall/climbing-wall.component';
import { GreeceComponent } from '../../nps/nps-games/greece/greece.component';
import { KoldunComponent } from '../../nps/nps-games/koldun/koldun.component';
import { MagicianComponent } from '../../nps/nps-games/magician/magician.component';
import { ArcherComponent } from '../../nps/nps-games/archer/archer.component';
import { Koldun2Component } from '../../nps/nps-games/koldun2/koldun2.component';
import { StrongmanComponent } from '../../nps/nps-games/strongman/strongman.component';

@Injectable({ providedIn: 'root' })
export class NpsGameLoaderService {
  loadComponent(modalName: string, container: ViewContainerRef, featureModuleRef?: NgModuleRef<any>): ComponentRef<NPSModal> | null {
    // Просто маппинг имени на класс компонента
    const componentMap: Record<string, Type<NPSModal>> = {
      freid: FreidComponent,
      witch: WitchComponent,
      puzzle: PuzzleComponent,
      payment: PaymentComponent,
      rider: ClimbingWallComponent,
      mirrors: GreeceComponent,
      koldun: KoldunComponent,
      magician: MagicianComponent,
      archer: ArcherComponent,
      koldun2: Koldun2Component,
      tugOfWar: StrongmanComponent,
    };

    const componentClass = componentMap[modalName];
    if (!componentClass) return null;

    // Всегда передаем featureModuleRef, Angular сам разберется, нужен он или нет
    return container.createComponent(componentClass, {
      ngModuleRef: featureModuleRef || undefined
    });
  }
}